$(document).ready(function () {
  if (!$("body").hasClass("template-page")) return;

  // main tabs
  $("[data-main-tab-switcher]").click(function () {
    const target = $(this).data("target");

    $("[data-main-tab-switcher]").removeClass("active");
    $(this).addClass("active");

    $("[data-main-tab]").removeClass("active");
    $(`[data-main-tab=${target}]`).addClass("active");
  });

  $("[data-target-tab]").click(function (e) {
    e.preventDefault();
    const target = $(this).data("target-tab");
    $(`[data-main-tab-switcher][data-target="${target}"]`).trigger("click");

    if (target === "products") {
      const firstProduct = $(".home-products .item").first();
      if (firstProduct.length) {
        $("html, body").animate(
          {
            scrollTop: firstProduct.offset().top - $("header").outerHeight(),
          },
          500,
        );
      }
    }
  });

  $(".accordion-item .expander").click(function () {
    $(this).closest(".accordion-item").toggleClass("expanded");
  });

  $(".home-modal-swiper").each(function (index, element) {
    const modalSwiper = $(element);
    const modalSwiperThumb = modalSwiper
      .parent()
      .find(".home-modal-swiper-thumb");
    if (!modalSwiperThumb.length) return;
    const modalSwiperThumbObj = new Swiper(modalSwiperThumb.get(0), {
      spaceBetween: 8,
      slidesPerView: "auto",
      centerInsufficientSlides: true,
      observer: true,
      observeParents: true,
    });
    new Swiper(element, {
      spaceBetween: 24,
      slidesPerView: 1,
      centeredSlides: true,
      centerInsufficientSlides: true,
      observer: true,
      observeParents: true,
      thumbs: {
        swiper: modalSwiperThumbObj,
      },
    });
  });

  const videoObj = $("video").get(0);
  new Swiper(".boosters-swiper", {
    spaceBetween: 26,
    slidesPerView: 1,
    centeredSlides: true,
    centerInsufficientSlides: true,
    observer: true,
    observeParents: true,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  new Swiper(".press-swiper", {
    spaceBetween: 24,
    slidesPerView: 1,
    centeredSlides: true,
    centerInsufficientSlides: true,
    observer: true,
    observeParents: true,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  new Swiper(".journals-swiper", {
    spaceBetween: 16,
    slidesPerView: 1.2,
    centeredSlides: true,
    centerInsufficientSlides: true,
    observer: true,
    observeParents: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  $("[data-modal-trigger]").click(function () {
    const id = $(this).data("modal-id");
    callJqueryModal(id, 200);
  });

  $(".custom-video-wrapper").click(function () {
    //removed video 7/11/24 https://nutrafol.atlassian.net/browse/NT2-19700
    return false;
    if (videoObj.paused) {
      videoObj.play();
      $(".play-container").hide();
      $("progress").show();
      $(".fullscreen-control").show();
    } else {
      videoObj.pause();
      $(".play-container").show();
      $("progress").hide();
      $(".fullscreen-control").hide();
    }
  });

  $(".fullscreen-control").click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    const elem = $("video").get(0);
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Chrome, Safari & Opera */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE/Edge */
      elem.msRequestFullscreen();
    }
  });

  $("video#about-video").bind("timeupdate", function () {
    const currentTime = videoObj.currentTime;
    const duration = videoObj.duration;
    $("progress").val((currentTime / duration) * 100);
    console.log((currentTime / duration) * 100);
  });
});
